import classNames from 'classnames';
import { format } from 'date-fns';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';
import { Link } from 'react-router-dom';
import { Input } from 'reactstrap';

import iconNotebook from '../../assets/img/icon-notebook-stud.svg';
import CarouselStudent from '../ChecklistEditorStudent/CaruselStudent';
import StudentHomeworkItem from '../CreateHomework/StudentHomeworkItem';

import './../ChecklistEditorStudent/style.scss';
import './style.scss';

const ChecklistView = ({ userEmail }) => {
  const [examItem, setExamItem] = useState();
  const [activeIndex, setActiveIndex] = useState(null);
  const [checkListView, setCheckListView] = useState();

  const { t } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    const showLocation = () => {
      if (location && location.state) {
        setCheckListView(location);
      } else {
        setCheckListView(examItem);
      }
    };
    showLocation();
  }, [location, examItem, checkListView]);

  useEffect(() => {
    if (location.state) {
      setExamItem(location);
    }
  }, [location]);

  const currentDate = format(new Date(), 'dd.MM.yyyy');

  return (
    <div className="student-carusel checklist-view">
      {checkListView && (
        <CarouselStudent>
          <div key={0} className="materials-page checklist-page imageSlide container">
            <div className="title-wrap">
              <h1>
                {t('checklist')} №{checkListView.state.examNumber}
              </h1>

              <div className="cource-name">
                <h3>
                  {t('subject')}: {checkListView.state.subject}
                </h3>
              </div>

              <div className="cource-name">
                <h3>
                  {t('Cource name')}: <span>{checkListView.state.name}</span>
                </h3>
              </div>
            </div>
            <div className="checlist-content">
              <p>
                {t(
                  'This is a control sheet. It contains tasks that you need to complete in turn. Put the date and your signature when you completed the task on the dash next to the task.',
                )}
              </p>
              <p>
                {t(
                  'Whenever you come across a word that you do not understand or the meaning of which you are not sure, consult a dictionary.',
                )}
              </p>
              <p>{t('If you have any questions, please contact your supervisor.')}</p>
              <p>
                {t('A supervisor is the head of the course and is there to help you get the most out of the course.')}
              </p>
              <div className="purpose-wrap">
                <div className="cource-purpose">
                  <h3>
                    {t('Purpose of the course')}: <span>{checkListView.state.purpose}</span>
                  </h3>
                </div>

                <div className="cource-purpose">
                  <h3>
                    {t('Prerequisites')}: <span>{checkListView.state.conditions}</span>
                  </h3>
                </div>

                <div className="cource-purpose">
                  <h3>
                    {t('class')}: <span>{checkListView.state.grade}</span>
                  </h3>
                </div>

                <div className="cource-purpose">
                  <h3>
                    {t('subject')}: <span>{checkListView.state.subject}</span>
                  </h3>
                </div>

                <div className="cource-purpose">
                  <h3>
                    {t('language')}: <span>{checkListView.state.lang}</span>
                  </h3>
                </div>
              </div>
            </div>
          </div>

          {Object.values(checkListView.state.chapter).map((slide, index) => {
            return (
              <div key={index + 1} className="materials-page checklist-page imageSlide container">
                <div className="slide">
                  <div className="checklist-item">
                    <h1>
                      {t('Chapter')} {index + 1}.
                    </h1>
                    <div className="checklist-item-top">
                      <h3>{t('materials')}:</h3>
                      <ul>
                        {slide &&
                          slide.materials &&
                          slide.materials.map((materialItem, materIndex) => {
                            return materialItem.url ? (
                              <li
                                key={materialItem.id}
                                onClick={() => {
                                  if (materialItem.url) {
                                    console.log('material!', materialItem);
                                    window.open(materialItem.url, '_blank');
                                  }
                                }}
                              >
                                <span className="material-numb">{materIndex + 1}.</span>
                                <div className="icon">
                                  <img src={iconNotebook} alt="icon" />
                                </div>
                                <div
                                  className={classNames('wrap', {
                                    'without-link': materialItem.url === '',
                                  })}
                                >
                                  <p>{materialItem.title}</p>
                                </div>
                              </li>
                            ) : (
                              <li key={materialItem.id}>
                                <span className="material-numb">{materIndex + 1}.</span>
                                <div className="icon">
                                  <img src={iconNotebook} alt="icon" />
                                </div>
                                <div className={classNames('wrap')}>
                                  <Link
                                    style={{ color: 'black' }}
                                    onClick={() => console.log('sd')}
                                    to={`/materialView?id=${
                                      materialItem && materialItem.studentMaterial && materialItem.studentMaterial.id
                                    }`}
                                    target="_blank"
                                  >
                                    <p>{materialItem.title}</p>
                                  </Link>
                                </div>
                              </li>
                            );
                          })}
                      </ul>
                    </div>

                    {slide &&
                      slide.points &&
                      slide.points.map((pointItem, pointIndex) => {
                        return (
                          <div key={index + pointIndex + index + slide.chapterNum} className="checklist-item-content">
                            <div
                              className="title-wrap"
                              onClick={() => {
                                if (activeIndex === `${pointIndex}_${slide.chapterNum}`) {
                                  setActiveIndex(null);
                                } else {
                                  setActiveIndex(`${pointIndex}_${slide.chapterNum}`);
                                }
                              }}
                            >
                              <h3>{`${t('point')} №${pointIndex + 1}${pointItem.star ? '*' : ''}`}</h3>

                              <span
                                className={classNames('icon icon-chevron-down', {
                                  revert: activeIndex === `${pointIndex}_${slide.chapterNum}`,
                                })}
                              ></span>
                            </div>

                            <div
                              className={`wrap-exum ${
                                activeIndex === `${pointIndex}_${slide.chapterNum}` ? 'open' : ''
                              }`}
                            >
                              <StudentHomeworkItem content={JSON.parse(pointItem.content)} checklist />
                            </div>

                            <div className="block-bottom">
                              <div className="data-row">
                                <div className="data-row-item">
                                  <h4>{t('Task completed')}</h4>

                                  <div className="checked-item completed">
                                    <Input
                                      className="homework-checkbox-input"
                                      checked={false}
                                      type="checkbox"
                                      readOnly
                                    />
                                    {currentDate}
                                  </div>
                                </div>

                                <div className="data-row-item">
                                  <h4>{t('Task checked')}</h4>

                                  <div className="checked-item checked">
                                    <Input
                                      className="homework-checkbox-input"
                                      checked={false}
                                      type="checkbox"
                                      readOnly
                                    />
                                    {currentDate}
                                  </div>
                                </div>
                              </div>
                              <div className="data-row-item notebook">
                                {pointItem.notebookLink && (
                                  <div className="checked-item checked">{t('Do in your notebook')}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                </div>
              </div>
            );
          })}

          <div key={3} className="materials-page checklist-page imageSlide last-slide container">
            <div className="title-wrap">
              <h1>{t('Completion of the course')}</h1>

              <ul className="last-page-list">
                <li>
                  <h3>{t('Student')}</h3>
                  <p>
                    {t(
                      'I have studied all the material to be studied and completed all the exercises on this checklist, and I can apply all the information I have learned in this course.',
                    )}
                  </p>
                  <div className="data-row-item">
                    <h4>{t('date')}</h4>

                    <div className="checked-item completed">
                      <Input className="homework-checkbox-input" checked={false} type="checkbox" readOnly />
                      {currentDate}
                    </div>
                  </div>
                </li>

                <li>
                  <h3>{t('Supervisor')}</h3>
                  <p>
                    {t(
                      'I certify that I have made every effort to teach this student and that he has studied all the material in this course and is able to apply the information he has learned.',
                    )}
                  </p>
                  <div className="data-row-item">
                    <h4>{t('date')}</h4>

                    <div className="checked-item exam">
                      <Input className="homework-checkbox-input" checked={false} type="checkbox" readOnly />
                      {currentDate}
                    </div>
                  </div>
                </li>

                <li>
                  <h3>{t('Course examiner')}</h3>
                  <p>
                    {t(
                      'Checks that the checklist is completely filled out and that the student has completed everything required in this course.',
                    )}
                  </p>
                  <div className="data-row-item">
                    <h4>{t('date')}</h4>

                    <div className="checked-item checked">
                      <Input className="homework-checkbox-input" checked={false} type="checkbox" readOnly />
                      {currentDate}
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </CarouselStudent>
      )}
    </div>
  );
};

export default ChecklistView;
